import React, { PropTypes } from 'react';
import { reduxForm } from 'redux-form';
import { fieldClass } from 'common/semantic/utils';

const validate = values => {
  const errors = {};
  if (!values.content) {
    errors.content = true;
  }

  return errors;
};

class AnswerForm extends React.Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    label: PropTypes.string.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
  };

  constructor(props, context) {
    super(props, context);

    this.goBack = this.goBack.bind(this);
  }

  goBack(evt) {
    evt.preventDefault();
    this.context.router.goBack();
  }

  render() {
    const { fields: { content }, label, handleSubmit, submitting } = this.props;

    return (
      <form className="ui form" onSubmit={handleSubmit}>
        <div className={fieldClass(content)}>
          <label>Réponse</label>
          <input
            type="text"
            name="content"
            placeholder="Contenu"
            {...content}
          />
        </div>
        <button
          className="ui right floated primary button"
          type="submit"
          disabled={submitting}
        >
          {label}
        </button>
        <button className="ui right floated button" onClick={this.goBack}>
          Annuler
        </button>
      </form>
    );
  }
}

AnswerForm.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default reduxForm(
  {
    form: 'answer',
    fields: ['content'],
    validate,
  },
  (state, ownProps) => {
    const { answer } = ownProps;
    return {
      initialValues: answer,
    };
  }
)(AnswerForm);



// WEBPACK FOOTER //
// ./src/modules/funnel/components/AnswerForm.js